/** Read the server's structured error without consuming ky's response. */
export async function readApiErrorEnvelope(err: unknown): Promise<{ code: string | null; message: string | null }> {
  const empty = { code: null, message: null };
  if (!err || typeof err !== 'object' || !('response' in err)) return empty;
  const response = err.response;
  if (!(response instanceof Response)) return empty;
  try {
    const body: unknown = await response.clone().json();
    if (!body || typeof body !== 'object') return empty;
    // Some registered Fastify routes use its flat error response. Only accept
    // matching client errors there; a raw 5xx message can contain server details.
    const nested = 'error' in body && body.error && typeof body.error === 'object' ? body.error : null;
    const error = nested ?? (response.status >= 400 && response.status < 500
      && 'statusCode' in body && body.statusCode === response.status ? body : null);
    if (!error) return empty;
    return {
      code: 'code' in error && typeof error.code === 'string' ? error.code : null,
      message: 'message' in error && typeof error.message === 'string' ? error.message : null,
    };
  } catch {
    return empty;
  }
}
